import { useMemo } from "react";

export const useClientPanel = () => {
  const hostname = window.location.hostname;

  const isClientPanel = useMemo(() => {
    const hostParts = window.location.hostname.split(".");

    if (hostParts.length < 3) {
      return false;
    }

    if (!["klient", "localklient"].includes(hostParts[0])) {
      return false;
    }

    return true;
  }, [hostname]);

  return {
    isClientPanel: isClientPanel,
  };
};
